import { TraitSale } from "types";
import * as traitSalesApi from "api/traitSalesApi";
import useFetchPromise from "hooks/useFetchPromise";

const useFetchTraitSales = () =>
  useFetchPromise<TraitSale[], boolean>(traitSalesApi.fetchTraitSales, true);

export default useFetchTraitSales;
